import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const SettingsIntegrationsLazy = loadable(
    () => import(/* webpackChunkName: "SettingsLight" */ './SettingsIntegrationsSuspense')
);

export const SettingsIntegrationsAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <SettingsIntegrationsLazy />
    </DelayedSuspense>
);
